import { render, staticRenderFns } from "./addresses.vue?vue&type=template&id=7553d232&scoped=true"
import script from "./addresses.vue?vue&type=script&lang=js"
export * from "./addresses.vue?vue&type=script&lang=js"
import style0 from "./addresses.vue?vue&type=style&index=0&id=7553d232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7553d232",
  null
  
)

export default component.exports